// extracted by mini-css-extract-plugin
module.exports = {"messagePopup":"_1L-sr","asRounded":"_38zQb","isExpanded":"_6a1hV"};